import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { componentStyles } from "./logos-title-component.scss";
import Title from "segments/desktop/core-components/title/title";
import DefaultProps from "./default-props";
class LogosTitleComponent extends PureComponent {
    render() {
        const { title, titleSize, textAlign, padding } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                textAlign,
                padding
            },
            className: `jsx-${componentStyles.__hash}` + " " + "logos-title-component",
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    title: title,
                    titleSize: titleSize
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { LogosTitleComponent as default };
LogosTitleComponent.defaultProps = DefaultProps;
